import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function SalesInventoryScale() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
